module.exports = __webpack_public_path__ + "static/media/buzzwords_words_end.19e09ba2.png";